<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="bp('emailDialogHeader')"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :z-index="16000011"
    :close-dialog-tooltip="bp('closeDialogToolTip')"
    @close="closeModal"
  >
    <p class="mb-4" qaid="project-one-email-dialog-message" v-html="bp('emailDialogMsg')" />
    <form @submit.prevent="sendEmail">
      <form-group
        v-model="emailAddress"
        v-validate="'required|email'"
        type="text"
        :name="bp('customerEmail').toLowerCase()"
        :maxlength="200"
        :label="bp('customerEmail')"
        :required="true"
        qaid="project-one-email-dialog-adderess-input"
        :show-error-messages="true"
        :error="errors.first(bp('customerEmail').toLowerCase())"
      />

      <form-group
        v-model="emailMessage"
        type="textarea"
        :name="bp('emailMsg').toLowerCase()"
        :maxlength="500"
        row="4"
        :label="bp('emailMsg')"
        :required="false"
        qaid="project-one-email-dialog-message-input"
        :show-error-messages="false"
      />

      <div class="buttons buttons--right">
        <trek-button qaid="project-one-email-dialog-save-btn" primary :disabled="!isEnabled" type="submit">
          <span v-html="bp('emailSend')" />
        </trek-button>

        <trek-button qaid="project-one-email-dialog-cancel-btn" secondary @click="closeModal">
          <span v-html="bp('cancel')" />
        </trek-button>
      </div>
    </form>
  </el-dialog>
</template>
<script>
import axios from 'axios';
import {mapMutations, mapState} from 'vuex';
import ElDialog from '@/components/Dialog';
import FormGroup from '@/components/FormGroup';
import TrekButton from '@/components/TrekButton.vue';

export default {
  name: 'ProjectOneSummaryEmailModal',

  components: {ElDialog, FormGroup, TrekButton},

  data() {
    return {
      emailAddress: '',
      emailMessage: '',
      isEnabled: false,
    };
  },

  computed: {
    isVisible: {
      get() {
        return this.isSummaryEmailModalVisible;
      },
      set(value) {
        this.setIsSummaryEmailModalVisible(value);
      },
    },

    ...mapState('projectOne', ['isSummaryEmailModalVisible', 'bikeData']),
  },

  watch: {
    //   Enable sumbit button only when it passes the email validation.
    emailAddress() {
      this.$validator.validate().then((isValid) => {
        this.isEnabled = isValid;
      });
    },
  },

  methods: {
    sendEmail() {
      var emailUrl = `/project-one/api/configurations/${this.bikeData.code}/sendconfigurationemail/`;

      axios
        .post(emailUrl, {
          contactEmail: this.emailAddress,
          p1Message: this.emailMessage,
          p1ConfigurationUrl: window.location.href,
        })
        .catch((er) => console.error(er))
        .finally(() => {
          //In the end
          this.closeModal();
        });
    },

    closeModal() {
      this.setIsSummaryEmailModalVisible(false);
    },

    ...mapMutations('projectOne', ['setIsSummaryEmailModalVisible']),
  },
};
</script>
